<template>
  <b-modal
    id="xendit-prompt-modal"
    centered
    title="Oops!">
    <p class="mt-3 text-center"> {{ message }} </p>
    <template slot="modal-footer">
      <b-button
        @click="$root.$emit('bv::hide::modal', 'xendit-prompt-modal')">Close</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: ['message']
}
</script>
